import { render, staticRenderFns } from "./ApplicationProcessCreate.vue?vue&type=template&id=8b83297a"
import script from "./ApplicationProcessCreate.vue?vue&type=script&lang=js"
export * from "./ApplicationProcessCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports